import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Cookies from "js-cookie";
import { FetchDataTypes } from "../api/api";
import { MultiSelect } from "react-multi-select-component";
import moment from "moment";
import filter, { concat } from "lodash";
import _ from "lodash";
//import DropdownMultiselect from "react-multiselect-dropdown-bootstrap";

const DualAxesChart = () => {
  const [sectorAllocation, setSectorAllocation] = useState<any>(null);
  const [mtdDays, setMtdDays] = useState<any>(null);
  const [setDate, setSetDate] = useState(90);
  const [currentPage, setCurrentPage] = useState(90);
  const [ytdDays, setYtdDays] = useState<any>(null);
  const [selected, setSelected] = useState([]);
  const [isselectedNASDAQComposite, setIsSelectedNASDAQComposite] = useState(null);
  const [NASDAQ, setNASDAQ] = useState(false)
  const [first, setfirst] = useState<any>(null)
  const [second, setSecond] = useState<any>(null)
  const [third, setThird] = useState<any>(null)

  const [benchMarkLabel, setBenchMarkLabel] = useState<any>(null);
  const [selectBenchMark, setSelectBenchMark] = useState<any>(null);
  const obj = { indexBenchmarkID: 0, indexBenchmarkName: "Select BenchMark" };
  //var toDate =
  const BeginDate = new Date(Date.now() - setDate * 24 * 60 * 60 * 1000);
  const EndDate = new Date();
  const yfd = new Date(EndDate.getFullYear(), 0, 1);
  const countDays = Math.abs(EndDate.getTime() - yfd.getTime());
  const ytd = countDays / (1000 * 3600 * 24);
 
  
  
  const a = moment().isBetween(BeginDate, EndDate);


function handleBanchMark(e:any){
  setSelected(e)
 
 e?.map((e:{value:number, label:string}) =>{
   if(e.value  === 1){
    setfirst(1)
   }else if(e.value === 2){
    setSecond(2)
   }else if(e.value === 3){
    setThird(3)
   }
   
 })
if(!e.length){
  setfirst(0)
  setSecond(0)
  setThird(0)
}
  //Object.keys(e).length === 1 ? setSecond(0) : setSecond(2)
}

function firstBenchmark(){
  return filteredData &&
  filteredData.map((e: any) => {
    return first === 1 ? e.oneBenchmarkPerf : null
  })
}

function secondBenchmark(){
  return filteredData &&
  filteredData.map((e: any) => {
    return second === 2 ? e.twoBenchmarkPerf : null
  })
}

function thirdBenchmark(){
  return filteredData &&
  filteredData.map((e: any) => {
    return third === 3 ? e.threeBenchmarkPerf : null
  })
}



  function getFirstDayOfMonth(year: any, month: any) {
    return new Date(year, month, 1);
  }

  const firstDayCurrentMonth = getFirstDayOfMonth(
    EndDate.getFullYear(),
    EndDate.getMonth()
  );
  const mtdCountDays = Math.abs(
    EndDate.getTime() - firstDayCurrentMonth.getTime()
  );
  const MTD = mtdCountDays / (1000 * 3600 * 24);


  const selectedClient:any = Cookies.get("client")
  useEffect(() => {
    FetchDataTypes("PortfolioPerformance", parseInt(selectedClient),Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setSectorAllocation(response);
      });
    setCurrentPage(setDate);
  }, [setDate]);

  useEffect(() => {
    FetchDataTypes("BenchmarkDetails", parseInt(selectedClient), Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setBenchMarkLabel([obj, ...response]);
      });
  }, []);

  useEffect(() => {
    setYtdDays(ytd.toFixed(0));
    setMtdDays(MTD.toFixed(0));
  }, [ytd, MTD]);

  var filteredData =
    sectorAllocation &&
    sectorAllocation.filter((e: any) => {
      var date = new Date(e.date);
      return date >= BeginDate && date <= EndDate;
    });

   
  useEffect(() => {
    benchMarkName();
  }, []);

  function benchMarkName() {
    const titleLabel = benchMarkLabel?.filter(
      (obj: any) => obj.indexBenchmarkID === 1
    );

    const data =
      titleLabel &&
      titleLabel.map((e: any) => {
        return e.indexBenchmarkName;
      });
 
    return data;
  }
  function currencyFormat(num: any) {
    return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }

  let options = {
    chart: {
      zoomType: "xy",
    width: 1100,
    },
    title: {
      text: "",
    },
    subtitle: {
      text: "",
    },
    plotOptions: {
      series: {
        lineWidth: 1,
        backgroundColor: "rgb(240,241,248)",
        marker: {
          enabled: false,
        },
        pointWidth: 10
      },
    },
    xAxis: [
      {
        categories:
          filteredData &&
          filteredData.map((e: any) => {
            let newDate =  e.date ;
            return moment(newDate).format('MMMM Do YYYY');
          }),
        crosshair: true,
      },
    ],
    yAxis: [
      {
        // Primary yAxis

        labels: {
          format: "{value}%",
          style: {
            color: "#806E89",
          },
        },
        title: {
          text: "Performance",
          style: {
            color: "#806E89",
          },
        },
      },
      {
        // Secondary yAxis

        title: {
          text: "Gain/Loss",
          style: {
            color: "#806E89",
          },
        },
        labels: {
          allowDecimals: true,
          format: "$ {value}",
          style: {
            color: "#806E89",
          },
        },
        opposite: true,
      },
    ],
    tooltip: {
      shared: true,
    },
    legend: {
      layout: "horizontal",
      align: "center",
      x: 0,
      verticalAlign: "bottom",
      y: 0,
      floating: false,
      backgroundColor: "rgba(255,255,255,0.25)",
      itemMarginTop: 0,
    },
    series: [
      {
        marker: {
          enabled: false,
        },
        name: "Gain/Loss",
        type: "column",
        yAxis: 1,
        data:
          filteredData &&
          filteredData.map((e: any) => {
            return e.gainLoss;
          }),

        tooltip: {
          valueSuffix: "",
        },
      },
      {
        name: "Performance",
        type: "spline",
        data:
          filteredData &&
          filteredData.map((e: any) => {
            return e.portfolioPerf;
          }),
        tooltip: {
          valueSuffix: "",
        },
      },
      {
        name: "NASDAQComposite",
        type: "spline",
        data:firstBenchmark()
        
      },
      {
        name: "DowJonesIndustrials",
        type: "spline",
        data:secondBenchmark()
      },
      {
        name: "SP500",
        type: "spline",
        data:thirdBenchmark()
      },
    ],
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 1000,
          },
        },
      ],
    },
  };

  return (
    <div className="card w-100">
      <div className="card-header">
        <h5 className="card-title float-start">Portfolio Performance</h5>

        <div className="float-end">
          <nav aria-label="Page navigation example">
            <ul className="pagination justify-content-end Portfolio_chat">
              <li
                className={
                  (currentPage !== mtdDays ? "" : "active") +
                  " page-item cursor-pointer"
                }
                onClick={() => setSetDate(mtdDays)}
              >
                <span className="page-link"> MTD</span>
              </li>
              <li
                className={
                  (currentPage !== 90 ? "" : "active") +
                  " page-item cursor-pointer"
                }
                onClick={() => setSetDate(90)}
              >
                <span className="page-link"> 3M</span>
              </li>
              <li
                className={
                  (currentPage !== 180 ? "" : "active") +
                  " page-item cursor-pointer"
                }
                onClick={() => setSetDate(180)}
              >
                <span className="page-link"> 6M</span>
              </li>
              <li
                className={
                  (currentPage !== ytdDays ? "" : "active") +
                  " page-item cursor-pointer"
                }
                onClick={() => setSetDate(ytdDays)}
              >
                <span className="page-link"> YTD</span>
              </li>
              <li
                className={
                  (currentPage !== 365 ? "" : "active") +
                  " page-item cursor-pointer"
                }
                onClick={() => setSetDate(365)}
              >
                <span className="page-link"> 1Y</span>
              </li>
            </ul>
          </nav>
        </div>
        <div className="float-end mx-4">
          <MultiSelect
        options={
         [ {label: "NASDAQComposite", value: 1}, 
          {label: "DowJonesIndustrials", value: 2},
          {label: "SP500", value: 3},
        ]
        }
        value={selected}
        onChange={handleBanchMark}
        labelledBy="Select Benchmark"
        className="multiSelect"
      />
        </div>
      </div>

      <div className="card-body d-flex w-100">
        <div className="align-self-center chart chart-lg">
          <div className="chartjs-size-monitor hight-chart">
            <HighchartsReact
              highcharts={Highcharts}
              options={options}
              oneToOne={true}
              width="1000px"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export { DualAxesChart };
